// Styles
import './SideBar.css'

const SideBar = ({ boards, activeBoardId, onSelectBoard, onAddBoard, onEditBoard, onDeleteBoard }) => {
    return (
        <div className='SideBar'>
            <p className='Sidebar-title'>Meus Quadros</p>
            <ul className='Sidebar-list'>
                {boards.map(board => (
                    <li
                        key={board.numBoard}
                        className={`Sidebar-item ${activeBoardId === board.numBoard ? 'active' : ''}`}
                        onClick={() => onSelectBoard(board.numBoard)}
                    >
                        <span className='Sidebar-item-icon'>{board.emoji}</span>
                        <span className='Sidebar-item-name'>{board.name}</span>

                        <div className='Sidebar-item-actions'>
                            <button
                                className='Sidebar-action-btn'
                                title='Editar quadro'
                                onClick={e => { e.stopPropagation(); onEditBoard(board) }}
                            >✏️</button>
                            <button
                                className='Sidebar-action-btn delete'
                                title='Excluir quadro'
                                onClick={e => { e.stopPropagation(); onDeleteBoard(board) }}
                            >🗑️</button>
                        </div>
                    </li>
                ))}
            </ul>

            <button className='Sidebar-add-btn' onClick={onAddBoard}>
                + Novo Quadro
            </button>
        </div>
    )
}

export default SideBar